import { Result } from "../../models/result";
import { School, SchoolStatus } from "../../models/school/school";
import { getFirestore, collection, getDoc, getDocs, doc, query, where, orderBy } from "firebase/firestore";

const db = getFirestore();

export const getSchoolById = async (schoolId) => {
   try{
    console.log(`schoolId: ${schoolId}`);
    const schoolRef = doc(db, "schools", schoolId);
    const schoolDoc = await getDoc(schoolRef);
    if(schoolDoc.exists()){
        const schoolData = School.fromMap(schoolDoc.data())
        return new Result({
            value: schoolData
        });
    }else{
        return new Result({message: "School not found"});
    }
   }catch(ex){
    console.log(`Error fetching school: ${ex}`);
    return new Result({message: `Error fetching school: ${ex.toString()}`});
   }
}


export const getAcademicYears = async(schoolId)=>{
    try{
        const schoolRef = doc(db, "schools", schoolId);
        const collRef = collection(schoolRef, "academic_years");
        const q = query(collRef, orderBy("academicYear", "desc"));
        const academicYears = [];
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            academicYears.push(doc.data().academicYear);
        });
        return new Result({
            value: academicYears,
        });
    }catch(ex){
        console.log(`Error fetching academic years: ${ex}`);
        return new Result({
            message: `Error fetching academic years: ${ex.toString()}`,
        });
    }
}

export const getClassesForSchool = async(schoolId)=>{
    try{
        const schoolRef = doc(db, "schools", schoolId);
        const collRef = collection(schoolRef, "classes");
        const snapShot = await getDocs(collRef);
        const classes = [];
        snapShot.forEach((doc) => {
            classes.push(doc.data());
        });

        for(const classItem of classes){
            const secRef = collection(schoolRef, "classes", `${classItem.Class}`, "divisions");
            const secSnapShot = await getDocs(secRef);
            const sections = [];
            secSnapShot.forEach((doc) => {
                sections.push(doc.id);
            });
            classItem.sections = sections;
        }
        return new Result({
            value: classes,
        });
    }catch(ex){
        console.log(`Error fetching classes: ${ex}`);
        return new Result({
            message: `Error fetching classes: ${ex.toString()}`,
        });
    }
}



